import PropTypes from 'prop-types';
import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import MatrixControl from './MatrixControl';
import MatrixWhy from '../response/MatrixWhy';
import SurveyAttachment from '../attachment/SurveyAttachment';
import * as Matrix from '../matrix/Matrix';
import SimpleLogicList from '../../survey_editor/preview/SimpleLogicList';

const MatrixButtonsQuestion = props => {
  const {
    add_why,
    choices,
    id,
    inputNamer = matrixFieldName,
    isDisabled,
    logic,
    name,
    pages,
    rows,
    showLogic,
    _type,
    why_text,
    bipolar,
  } = props;
  return (
    <QuestionWrapper {...props}>
      <Matrix.Table>
        <Matrix.Head>
          {choices.map((choice, choiceIndex) => (
            <th className="fs-12 ta-c fw-n v-bottom" key={choiceIndex}>
              {choice.id && (
                <SurveyAttachment id={choice.id} inlineVideo={false} />
              )}
              <span dangerouslySetInnerHTML={{ __html: choice.text }} />
            </th>
          ))}
        </Matrix.Head>
        {rows.map((row, rowIndex) => (
          <Matrix.Body key={rowIndex}>
            <Matrix.Row
              based_on={row.based_on}
              id={row.id || row.name}
              text={row.text}
              comparison_text={row.comparison_text}
              other={row.other}
              questionId={id}
              questionName={name}
              bipolar={bipolar}
            >
              {choices.map((choice, choiceIndex) => (
                <td
                  className="chc"
                  key={choiceIndex}
                  style={{ width: Matrix.cellWidth(choices.length) }}
                >
                  <MatrixControl
                    className="bc-eee ta-c pv3 d-b"
                    disabled={isDisabled}
                    id={`questions_${name}-${row.name}_${choice.name}`}
                    label={choice.text}
                    name={inputNamer(_type, name, row.name)}
                    rowIndex={rowIndex}
                    questionId={id}
                    type={
                      _type === 'Survey::SingleSelect' ? 'radio' : 'checkbox'
                    }
                    value={choice.name}
                  />
                </td>
              ))}
              {showLogic && logic && logic.length ? (
                <td style={{ backgroundColor: 'white', paddingLeft: '1rem' }}>
                  <SimpleLogicList
                    logic={logic.filter(term => term.matrix_row_id === row.id)}
                    pages={pages}
                    showChoiceLabel={true}
                  />
                </td>
              ) : null}
            </Matrix.Row>
            <MatrixWhy
              add_why={add_why}
              colSpan={choices.length + 1}
              disabled={isDisabled}
              id={id}
              name={name}
              rowName={row.name}
              rowIndex={rowIndex}
              why_text={why_text}
            />
          </Matrix.Body>
        ))}
      </Matrix.Table>
    </QuestionWrapper>
  );
};

const matrixFieldName = (_type, name, rowName) =>
  _type === 'Survey::SingleSelect'
    ? `questions[${name}-${rowName}]`
    : `questions[${name}-${rowName}][]`;

MatrixButtonsQuestion.propTypes = {
  _type: PropTypes.string,
  add_none: PropTypes.bool,
  add_dont_know: PropTypes.bool,
  add_other: PropTypes.bool,
  add_why: PropTypes.bool,
  choices: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  ranking: PropTypes.bool,
  required: PropTypes.bool,
  rows: PropTypes.array.isRequired,
  text: PropTypes.string.isRequired,
  why_text: PropTypes.string,
};

export default MatrixButtonsQuestion;
